import { VscClose } from "react-icons/vsc";
import { useState, useEffect } from "react";
import { BaseNotification } from "@/core/api/types/notifications";
import { motion, AnimatePresence } from "framer-motion";

export default function HeavyNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState<BaseNotification | null>(
    null
  );

  useEffect(() => {
    console.log("🎯 HeavyNotification mounted");

    const handleHeavyNotification = (event: CustomEvent<BaseNotification>) => {
      console.log("👋 Heavy notification event received in component");
      setNotification(event.detail);
      setIsVisible(true);
    };

    window.addEventListener(
      "heavy_notification_received",
      handleHeavyNotification as EventListener
    );

    return () => {
      window.removeEventListener(
        "heavy_notification_received",
        handleHeavyNotification as EventListener
      );
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && notification && (
        <motion.div
          initial={{ opacity: 0, y: -20, x: 20 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{
            type: "spring",
            stiffness: 500,
            damping: 40,
            mass: 1,
          }}
          className="fixed bottom-4 left-4 z-[99999]"
        >
          <div className="flex items-start gap-3 bg-white rounded-lg shadow-lg border border-gray-200 p-4 max-w-[350px]">
            <div className="flex flex-shrink-0 justify-center items-center w-10 h-10 bg-red-100 rounded-full">
              <div className="w-3 h-3 rounded-full bg-edPrimaryColor-500" />
            </div>

            <div className="flex-1">
              <h3 className="text-sm font-semibold text-gray-900">
                {notification.title}
              </h3>
              <p className="mt-1 text-sm text-gray-600">
                {notification.message}
              </p>
            </div>

            <button
              onClick={() => setIsVisible(false)}
              className="p-1 rounded-full transition-colors hover:bg-gray-100"
            >
              <VscClose className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
